import {IntermediatePart} from "../../intermediatePart";

export default class TallHandle extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'tall_handle';
    this.partName = 'Tall Handle';
    this.translateId = "visualizer.kitchen.cabinet.tall_handle";
    this.hasAdditionalParts = true;
    this.canBeDisabled = true;
  }

}
